import { useState, type ReactNode } from 'react';

export interface ConfirmButtonProps {
  readonly children: ReactNode;
  readonly confirmLabel: string;
  readonly onConfirm: () => void;
  readonly busy?: boolean;
}

/** A destructive action that needs a second click to go through. */
export function ConfirmButton({ children, confirmLabel, onConfirm, busy = false }: ConfirmButtonProps) {
  const [armed, setArmed] = useState(false);
  if (!armed) {
    return (
      <button type="button" className="secondary" onClick={() => setArmed(true)} disabled={busy}>
        {children}
      </button>
    );
  }
  return (
    <div role="group">
      <button type="button" className="contrast" onClick={onConfirm} aria-busy={busy} disabled={busy}>
        {confirmLabel}
      </button>
      <button type="button" className="secondary outline" onClick={() => setArmed(false)} disabled={busy}>
        Cancel
      </button>
    </div>
  );
}
